import styled from 'styled-components';

const TableBody = styled.div`
	display: flex;
	flex-direction: column;
`;

export default TableBody;
